import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { OKAlert } from "cpl-react-common/components/Alerts/Okay";
import { useDispatch, useSelector } from "react-redux";
import { clearError, selectErrorDetails, selectErrorMessage, selectShowErrorMessage } from "./ServerErrorAlertSlice";

export const ServerErrorAlert: React.FC = () => {
  const dispatch = useDispatch();
  const showErrorMessage = useSelector(selectShowErrorMessage);
  const errorMessage = useSelector(selectErrorMessage);
  const errorDetails = useSelector(selectErrorDetails);

  function dismissErrorAlert() {
    dispatch(clearError());
  }

  const alertBody = (
    <div>
      <p>{errorMessage}</p>
      {errorDetails && (
        <div>
          <div className="text-break">
            <strong>Path:</strong> {errorDetails.path}
          </div>
          <div>
            <strong>Time:</strong> {new Date(errorDetails.timestamp).toCPLDateTimeString()}
          </div>
          <div>
            <strong>Ref:</strong> {errorDetails.referenceID}
          </div>
        </div>
      )}
    </div>
  );

  return (
    <OKAlert
      showAlert={showErrorMessage}
      alertText={alertBody}
      alertTitle="Error"
      callBack={dismissErrorAlert}
      style={Style.Warning}
    />
  );
};
